import { type CreateReportDto, type DataQualityReport} from '@enmon/commons/lib/enmon/data-quality';
import { BaseApiClient } from '../baseApiClient';

export class BackendGatewayDataQualityApiClient extends BaseApiClient {
  constructor(jwt: string) {
    super('enmon-tools/data-quality', undefined, jwt);
  }

  public async createReport(args: CreateReportDto): Promise<DataQualityReport> {
    const response = await this.axios.post<DataQualityReport>('/report', args);

    return response.data;
  }
}
